import { filterClearIcon } from "@tql/ui-components-react/kendo/svg-icons";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { refreshCcw_03 } from "@tql/ui-components-react/untitled/icons";

import { ColumnChooser } from "~/shared/components/column-chooser/column-chooser.tsx";
import { useIsMobile } from "~/shared/hooks/use-is-mobile.ts";
import type { BoardColumn } from "~/shared/types/quote-board-types";

export const LoadsHeader = ({
	columns,
	onChangeColumn,
	onClearFilters,
	onRefresh,
	onResetColumns,
}: {
	columns: BoardColumn[];
	onChangeColumn: (column: BoardColumn) => void;
	onClearFilters: () => void;
	onRefresh: () => void;
	onResetColumns?: () => void;
}) => {
	const isMobile = useIsMobile();
	return (
		<div className={"flex-header"}>
			<div className={"loads-header-actions"}>
				<Button
					aria-label={"Refresh"}
					onClick={onRefresh}
					svgIcon={refreshCcw_03}
					title={"Refresh"}
					variant={"tertiary"}
				/>
				<Button
					aria-label={"Clear filters"}
					onClick={onClearFilters}
					svgIcon={filterClearIcon}
					title={"Clear filters"}
					variant={"tertiary"}
				/>
				{!isMobile && (
					<ColumnChooser
						secondary
						columns={columns}
						onColumnToggle={onChangeColumn}
						onResetColumns={onResetColumns}
					/>
				)}
			</div>
		</div>
	);
};
